import { computeValue } from "../../../core";
import { assert, isNil, isNumber } from "../../../util";
const $exp = (obj, expr, options) => {
  const n = computeValue(obj, expr, null, options);
  if (isNil(n))
    return null;
  assert(isNumber(n) || isNaN(n), "$exp expression must resolve to a number.");
  return Math.exp(n);
};
export {
  $exp
};
